import { GlobalState } from '@/store/global/typing';

export const globalState: GlobalState = {
  amountOfRiskWarningElements: 0,
  headerHeight: 96,
};
